import { Actions } from '../../interfaces'

import find from './find'
import { ProductApproach } from '@/entities/settings'

export const actions: Actions = {
  find,
}

export default {
  Model: { ProductApproach },
  actions: { [ProductApproach.name]: actions },
}
